export const getKeys = (widgetItemOperations, criteria) => {
  const keys = [];
  if (widgetItemOperations) {
    widgetItemOperations?.data?.widgetItems?.[0]?.itemsOperations.forEach(
      (item) => {
        if (item[criteria]) {
          keys.push(item);
        }
      }
    );
  }
  return keys;
};
